import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ModulePermissionsProvider } from './contexts/ModulePermissionsContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import Dashboard from './components/dashboard/Dashboard';
import SessionTimeoutWarning from './components/common/SessionTimeoutWarning';
import ErrorBoundary from './components/common/ErrorBoundary';
import { initializePWA } from './utils/pwa';
import './App.css';
import { logger } from './utils/logger';

const AppContent = () => {
  const { isAuthenticated, isLoading, isInTwoFactorFlow } = useAuth();
  const [showRegister, setShowRegister] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  useEffect(() => {
    initializePWA().then((status) => {
      logger.log('PWA Status:', status);
    });
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-300">Chargement...</p>
        </div>
      </div>
    );
  }

  // ✅ Pages non authentifiées OU phase 2FA
  if (!isAuthenticated || isInTwoFactorFlow) {
    if (showForgotPassword) {
      return <ForgotPassword onBackToLogin={() => setShowForgotPassword(false)} />;
    }
    if (showRegister) {
      return <Register onBackToLogin={() => setShowRegister(false)} />;
    }
    return (
      <Login 
        onSwitchToRegister={() => setShowRegister(true)}
        onSwitchToForgotPassword={() => setShowForgotPassword(true)}
      />
    );
  }

  // ✅ Pages authentifiées - Charger les Providers UNIQUEMENT si connecté ET pas en 2FA
  return (
    <ModulePermissionsProvider>
      <NotificationProvider>
        <DataProvider>
          <Dashboard />
          <SessionTimeoutWarning />
        </DataProvider>
      </NotificationProvider>
    </ModulePermissionsProvider>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;